import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useEffect, useState } from 'react';
import api from 'services/api';

export default function useToggleActive(document, setToRefresh) {
  const { setValidationModal, user, setResponseMsg, setLoading } =
    useContext(GlobalContext);

  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(!!document?.Ativo);
  }, [document]);

  function submitStatus(newValue) {
    return () =>
      api
        .postStatus(user, document.ID, newValue, document.TipoDoc)
        .then(() => setToRefresh(Date.now()))
        .catch((error) => {
          console.error(error);
          setResponseMsg({
            isVisible: true,
            error: true,
            msg: error.message,
          });
        })
        .finally(() => setLoading(false));
  }

  function handleActive(newValue) {
    setValidationModal({
      isVisible: true,
      title: 'Mudança de Status',
      text: 'Tem certeza de que deseja alterar o status atual para',
      emphasis: newValue ? 'Ativo?' : 'Inativo?',
      callback: submitStatus(newValue),
    });
  }

  return { active, handleActive };
}
